// @ts-nocheck

import { createSelector } from 'reselect';

import { isLibrary } from '../../lib/useragent';
import { selectRuntimeIsWTVEnabled } from '../../selectors/runtime/runtimePrimary.selector';
import { selectUserPrefsShowWTV } from '../../selectors/user/userPrimary.selector';

const selectShowTv = createSelector(selectUserPrefsShowWTV, (showWTV) => !isLibrary && showWTV);

const selectIsWtvEnabled = createSelector([selectRuntimeIsWTVEnabled], (isWTVEnabled) => !isLibrary && isWTVEnabled);

const selectTVBarProps = createSelector([selectIsWtvEnabled, selectShowTv], (isWTVEnabled, showWTV) => ({
  isWTVEnabled,
  showWTV,
}));

export default selectTVBarProps;
